var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quick-book_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469",
    stopOpacity: 0.219
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quick-book_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "83.336%",
    y2: "16.664%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quick-book_svg__c",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#quick-book_svg__a)",
    rx: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#quick-book_svg__b)",
    d: "M17.747 0H2.127C.967 0 0 .968 0 2.126v11.937c0 1.18.968 2.126 2.126 2.126h1.937c-.02-.231-.042-.463-.042-.694 0-.253.021-.484.042-.716H2.126a.71.71 0 01-.715-.716v-9.22h17.031v9.241a.71.71 0 01-.716.716H15.79c.022.232.043.484.043.716 0 .231-.021.463-.043.695h1.937c1.18 0 2.127-.969 2.127-2.127V2.126A2.105 2.105 0 0017.747 0zM2.927 3.158a.751.751 0 01-.759-.737c0-.4.337-.737.758-.737.4 0 .737.337.737.737 0 .4-.337.737-.737.737zm2.189 0a.746.746 0 01-.737-.737c0-.4.337-.737.737-.737.42 0 .737.337.737.737 0 .4-.316.737-.737.737zm2.19 0a.733.733 0 01-.738-.737c0-.4.337-.737.737-.737.4 0 .737.337.737.737 0 .4-.337.737-.737.737zm9.136-.084h-2.926a.679.679 0 01-.674-.674c0-.379.316-.674.674-.674h2.905c.379 0 .674.295.674.674a.649.649 0 01-.653.674z",
    transform: "translate(11 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#quick-book_svg__c)",
    d: "M9.937 11.032c-2.484 0-4.484 2-4.484 4.484S7.453 20 9.937 20s4.484-2 4.484-4.484-2-4.484-4.484-4.484zm2.042 3.979l-2.021 2.02a.682.682 0 01-.505.211.687.687 0 01-.506-.21l-1.052-1.053a.723.723 0 010-1.01.723.723 0 011.01 0l.548.547L10.968 14a.723.723 0 011.01 0 .721.721 0 010 1.01z",
    transform: "translate(11 11)"
  }))));
}
export default SvgQuickBook;